
import React, { ReactNode, useState, useEffect } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Los modales ahora siguen la regla binaria: sólo oscuros en tema 'dark'
    return localStorage.getItem('app_theme') === 'dark';
  });

  useEffect(() => {
    const handleThemeChange = () => {
      const theme = localStorage.getItem('app_theme');
      setIsDarkMode(theme === 'dark');
    };
    window.addEventListener('app_theme_changed', handleThemeChange);
    return () => window.removeEventListener('app_theme_changed', handleThemeChange);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div className={`rounded-[28px] shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200 border ${isDarkMode ? 'bg-[#2a2d34] border-gray-700' : 'bg-white border-gray-100'}`}>
        <div className={`flex justify-between items-center p-6 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
          <h3 className={`text-sm font-black uppercase tracking-widest ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>{title}</h3>
          <button onClick={onClose} className={`p-2 rounded-full transition-colors ${isDarkMode ? 'text-gray-500 hover:text-red-400 hover:bg-red-400/10' : 'text-gray-400 hover:text-red-500 hover:bg-red-50'}`}>
            <X size={20} />
          </button>
        </div>
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
